import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { reactive, ref, watch } from 'vue';
import { useComponentModalInstance } from '@/share/components';

import { fetchApi } from '/Users/ytx/ytx/projects/jxpj/web/jxpj-client/src/server/auto-import.js';
export default {
  __name: 'mg-u-dict-item-form',
  props: {
    id: {
      type: String,
      default: ''
    },
    cate: {
      type: String,
      default: ''
    } // 数据项字典分类id,添加时必须传入
  },
  setup(__props, {
    expose: __expose
  }) {
    const formRef = ref();
    const $modal = useComponentModalInstance();
    const props = __props;
    const formData = reactive({
      id: '',
      title: '',
      value: '',
      status: 0,
      summary: ''
    });
    const formRules = reactive({
      title: [{
        required: true,
        message: '标题不能为空',
        trigger: 'blur'
      }],
      value: [{
        required: true,
        message: '值不能为空',
        trigger: 'blur'
      }]
    });
    const validate = async () => {
      const $form = formRef.value;
      if (!$form) return Promise.resolve(false);
      const errors = await $form.validate();
      if (errors) return Promise.resolve(false);
      return Promise.resolve(true);
    };
    const {
      loading,
      runAsync: getDictionaryDetailApi
    } = fetchApi('common.uDictionary.getDetail');
    const {
      loading: saveLoading,
      runAsync: saveDictionaryApi
    } = fetchApi('common.uDictionary.save');
    const updateModalConfirmButtonLoading = loading => {
      if (!$modal) return;
      $modal.setModalOptions({
        confirmLoading: loading
      });
    };
    const submit = async () => {
      const valid = await validate();
      if (!valid) return Promise.resolve(false);
      const postData = {
        ...formData,
        id: props.id
      };
      if (!props.id) {
        postData.cate = props.cate;
      }
      const {
        error,
        ...res
      } = await saveDictionaryApi(postData);
      if (error) return Promise.resolve(false);
      return Promise.resolve(res);
    };
    async function loadDetail(id) {
      if (!id) return Promise.resolve(false);
      const {
        error,
        ...res
      } = await getDictionaryDetailApi({
        id
      });
      if (error) return Promise.resolve(false);
      Object.assign(formData, res);
      return Promise.resolve(res);
    }
    watch(() => props.id, id => {
      loadDetail(id).catch(() => {});
    }, {
      immediate: true
    });
    watch(() => saveLoading.value, loading => {
      updateModalConfirmButtonLoading(loading);
    });
    __expose({
      validate,
      submit,
      confirmListener: submit
    });
    return (_ctx, _cache) => {
      const _component_vxe_input = _resolveComponent("vxe-input");
      const _component_vxe_form_item = _resolveComponent("vxe-form-item");
      const _component_vxe_textarea = _resolveComponent("vxe-textarea");
      const _component_vxe_radio = _resolveComponent("vxe-radio");
      const _component_vxe_radio_group = _resolveComponent("vxe-radio-group");
      const _component_vxe_form = _resolveComponent("vxe-form");
      return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_vxe_form, {
        ref_key: "formRef",
        ref: formRef,
        "title-width": 100,
        "title-colon": "",
        "title-align": "right",
        loading: _unref(loading),
        data: formData,
        rules: formRules
      }, {
        default: _withCtx(() => [_createVNode(_component_vxe_form_item, {
          span: "12",
          field: "title",
          title: "项标题"
        }, {
          default: _withCtx(() => [_createVNode(_component_vxe_input, {
            modelValue: formData.title,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => formData.title = $event),
            placeholder: "请输入标题"
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_vxe_form_item, {
          span: "12",
          field: "value",
          title: "项值"
        }, {
          default: _withCtx(() => [_createVNode(_component_vxe_input, {
            modelValue: formData.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => formData.value = $event),
            placeholder: "请输入值"
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_vxe_form_item, {
          span: "24",
          field: "summary",
          title: "说明"
        }, {
          default: _withCtx(() => [_createVNode(_component_vxe_textarea, {
            modelValue: formData.summary,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => formData.summary = $event),
            autosize: {
              minRows: 1,
              maxRows: 3
            }
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_vxe_form_item, {
          span: "24",
          field: "status",
          title: "状态"
        }, {
          default: _withCtx(() => [_createVNode(_component_vxe_radio_group, {
            modelValue: formData.status,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => formData.status = $event)
          }, {
            default: _withCtx(() => [_createVNode(_component_vxe_radio, {
              "checked-value": 0
            }, {
              default: _withCtx(() => [...(_cache[4] || (_cache[4] = [_createTextVNode("使用", -1)]))]),
              _: 1
            }), _createVNode(_component_vxe_radio, {
              "checked-value": 1
            }, {
              default: _withCtx(() => [...(_cache[5] || (_cache[5] = [_createTextVNode("停用", -1)]))]),
              _: 1
            })]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        })]),
        _: 1
      }, 8, ["loading", "data", "rules"])]);
    };
  }
};